const config = {
    accessToken: process.env.REACT_APP_STORYBLOK_TOKEN,
    cache: {
        clear: 'auto',
        type: 'memory',
    },
};

export default config;
